import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const amazonRDSOption: Option<CriteriaKey> = {
  name: 'Amazon Relational Database Service (RDS)',
  description:
    'A fully-managed database service that makes it easy to set up, operate, and scale relational databases in the cloud',
  tags: ['SQL', 'Relational'],
  pros: ['Wide range of database engines', 'Automated backups and maintenance'],
  cons: ['Performance limitations', 'Limited control over infrastructure'],
  documentationLink: 'https://aws.amazon.com/rds/',
  criteriaScores: {
    availability: { score: { value: 7 } },
    securityAndCompliance: { score: { value: 9 } },
    performanceAndScalability: { score: { value: 7 } },
    dataConsistency: { score: { value: 10 } },
    dataStructure: { score: { value: 10 } },
    costOptimization: { score: { value: 6 } },
    dataPersistence: { score: { value: 9 } },
  },
};
